<template>
    <div class="crm">
      <!-- <page-header
          title="Requests"
          breadcrumb="Bookings & Shipments > Dispatch Management > Requests"
      /> -->
      <div class="">
        <div class="flex justify-between my-4 pt-8 border-b-2 border-[#B7BDCD]">
          <div class="flex">
            <div
              :class="{ active: currentTab == 'handsoff' }"
              class="tab-item"
              @click="currentTab = 'handsoff'"
            >
              <p>Hand-Off</p>
            </div>
            <!-- <div
              :class="{ active: currentTab == 'fulfillment' }"
              class="tab-item"
              @click="currentTab = 'fulfillment'"
              hidden
            >
              <p>Fulfillment</p>
            </div> -->
            <div
              :class="{ active: currentTab == 'return' }"
              class="tab-item"
              @click="currentTab = 'return'"
            >
              <p>Returns</p>
            </div>
          </div>
        </div>
        <requests-table class="mt-5" :currentTab="currentTab" />
        
        
      </div>
    </div>
  </template>
  
  <script>
  // import PageHeader from "@/components/UI/NewPageHeader";
  import RequestsTable from "@/components/3pl/Operations/Requests/BookingRequestsTable"
  
  export default {
    components: {
      // PageHeader,
      RequestsTable,
    },
    data() {
      return {
        currentTab: "handsoff",
        dispatches : [],
        loadingDispatches : true
      };
    },
    
    created(){
    },
    watch : {
      
    },
    methods : {
      
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .el-date-editor.el-input {
    margin-bottom: 0;
  }
  .tab-item {
    cursor: pointer;
    // margin-right: 1rem;
    color: #5e646d;
    padding: 0.25rem 1.5rem;
    font-size: 0.9rem;
    &.active {
      background: #ffffff;
      box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
      border-radius: 5px;
      color: #fcc210;
      font-weight: bold;
    }
  }
  </style>
  